module.exports = __webpack_public_path__ + "img/phone_3.4a0ede26.png";